import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import HeaderBottom from "../components/Admin/Settings/HeaderBottom";

const ErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Your Website</title>
        <meta
          name="description"
          content="Sorry, the page you’re looking for doesn’t exist or has been moved. Go back to the homepage or explore other sections."
        />
      </Helmet>

      <HeaderBottom />

      <section className=" mt-5 error-page-area flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 text-center px-4">
        <div className="max-w-4xl mx-auto animate-fadeIn">
          <div className="flex flex-col md:flex-row items-center gap-10">
            
            {/* Image Section */}
            <div className="w-full md:w-1/2 flex justify-center">
              <img
                src="https://i.ibb.co/ccz4r0V4/404-1.png"
                alt="404 Error"
                className="max-w-sm md:max-w-md drop-shadow-lg transition-transform duration-300 hover:scale-105"
              />
            </div>

            {/* Text Section */}
            <div className="w-full md:w-1/2 text-gray-800">
              <h1 className="text-8xl font-extrabold text-indigo-600 mb-4">404</h1>
              <h2 className="text-3xl font-bold mb-3">Oops! Page Not Found</h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                The page you’re looking for doesn’t exist or has been moved. Let’s get you back on track!
              </p>
              
              <Link
                to="/"
                className="cs_btn cs_style_1 cs_purple_bg cs_white_color cs_video_open wow fadeInLeft"
              >
                Go Back Home
              
              </Link>
            </div>
          </div>
        </div>
      </section>

     
      
    </>
  );
};

export default ErrorPage;

